function resizeGame () {
  let game = this;

  var canvas = document.querySelector('canvas');
  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;
  var windowRatio = windowWidth / windowHeight;
  var gameRatio = game.config.width / game.config.height;
  if (windowRatio < gameRatio) {
    canvas.style.width = windowWidth + 'px';
    canvas.style.height = (windowWidth / gameRatio) + 'px';
  } else {
    canvas.style.width = (windowHeight * gameRatio) + 'px';
    canvas.style.height = windowHeight + 'px';
  }
}

function countGlobalChildren (scenes) {
  let childrenCount = 0;
  for (let s of scenes) {
    childrenCount += s.children.length;
  }
  return childrenCount;
}

function numberMap (n, aStart, aStop, bStart, bStop) {
  return bStart + (bStop - bStart) * ((n - aStart) / (aStop - aStart));
}

function rotatePointAround (point, x, y, angle, distance) {
  point.x = x + (distance * Math.cos(angle));
  point.y = y + (distance * Math.sin(angle));

  return point;
}

const utils = {
  resizeGame,
  countGlobalChildren,
  numberMap,
  rotatePointAround
};

module.exports = utils;
